import { TextField } from '@mui/material';

export function toMonthValue(
  year: number | '' | null | undefined,
  month: number | '' | null | undefined,
): string {
  if (typeof year !== 'number' || typeof month !== 'number' || month < 1 || month > 12) return '';
  return `${year}-${String(month).padStart(2, '0')}`;
}

export function fromMonthValue(value: string): { year: number | null; month: number | null } {
  const match = /^(\d{4})-(\d{2})$/.exec(value);
  if (!match) return { year: null, month: null };
  const month = Number(match[2]);
  if (month < 1 || month > 12) return { year: null, month: null };
  return { year: Number(match[1]), month };
}

export interface MonthFilterFieldProps {
  label: string;
  /** `YYYY-MM`, ou vazio quando o filtro não está aplicado. */
  value: string;
  onChange: (value: string) => void;
  fullWidth?: boolean;
  disabled?: boolean;
  sx?: object;
}

/** Filtro de um mês fechado. O rótulo diz se é competência ou emissão. */
export function MonthFilterField({
  label,
  value,
  onChange,
  fullWidth,
  disabled,
  sx,
}: MonthFilterFieldProps): JSX.Element {
  return (
    <TextField
      type="month"
      size="small"
      label={label}
      value={value}
      onChange={(event) => onChange(event.target.value)}
      fullWidth={fullWidth}
      disabled={disabled}
      InputLabelProps={{ shrink: true }}
      sx={{ width: fullWidth ? undefined : 190, ...sx }}
    />
  );
}
